import { BLUE_GREY_200, LILAC_200, WHITE } from '../colors';
var cardConfig = {
  theme: 'light',
  borderColor: WHITE,
  backgroundColor: LILAC_200,
  showShadow: true,
  paddingToken: 'SPACING_16'
};
var whiteTheme = Object.assign(Object.assign({}, cardConfig), {
  theme: 'white',
  borderColor: BLUE_GREY_200,
  backgroundColor: WHITE,
  showShadow: false
});
export default {
  light: cardConfig,
  dark: cardConfig,
  white: whiteTheme
};